import { render, staticRenderFns } from "./handler.vue?vue&type=template&id=d4e46a64&"
import script from "./handler.vue?vue&type=script&lang=ts&"
export * from "./handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports